import { action, thunk, computed } from 'easy-peasy';
import { getDomains, createDomain, checkDomain } from '../services/Domains';

const DomainListModel = {
  domains: [],
  credits: 0,
  good_domains: computed(
    state => state.domains.filter(domain => domain.status === 'good')
  ),
  checkDomain: thunk(async (actions, domain) => {
    await checkDomain(domain);
    await actions.getDomains();
  }),
  showDomains: action((state, new_domains) => {
    state.credits = new_domains.credits;
    let domain_list = new_domains.domains;
    const existing = new Set(state.domains.map(domain => domain.domain));
    const new_ = new Set(domain_list.map(domain => domain.domain));
    if (existing !== new_) {
      state.domains = domain_list;
    }
  }),
  getDomains: thunk(async (actions, _, {getStoreActions}) => {
    let domains = await getDomains();
    getStoreActions().setInitialDomain(domains.domains[0])
    actions.showDomains(domains);
  }),
  createDomain: thunk(async (actions, domain) => {
    let result = await createDomain(domain);
    await actions.getDomains();
    return result;
  })
};

export default DomainListModel;
